import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pageTitle: {
    description: 'Page title for the Automations page',
    defaultMessage: 'Automations Overview',
    id: '5eihZd',
  },
  automationPlaybookTitle: {
    description: 'Section heading for the Automation Playbook section',
    defaultMessage: 'Automation Playbook',
    id: 'vjju9k',
  },
  automationToolsTitle: {
    description: 'Section heading for the Automation Tools section',
    defaultMessage: 'Automation Tools',
    id: 'Mp2AZ7',
  },
  learnMore: {
    description: 'Learn More link label in the Automation Tools section header',
    defaultMessage: 'Learn More',
    id: 'QiFB2p',
  },
});
